import React from "react";
import CountUp from "react-countup";
import {
  FaCalendarAlt,
  FaAward,
  FaUsers,
  FaProjectDiagram,
  FaUserTie,
  FaHeadset,
} from "react-icons/fa";

import "./Stats.css";

export default function Stats() {
  return (
    <section className="stats-section">

      {/* Est. 1998 */}

      <div className="stats-card">
        <FaCalendarAlt className="icon" />

        <h3>Est. 1998</h3>

        <p>Serving Since 1998</p>
      </div>

      {/* 25+ */}

      <div className="stats-card">
        <FaAward className="icon" />

        <h3>
          <CountUp
            end={25}
            duration={2.5}
            suffix="+"
            enableScrollSpy
            scrollSpyOnce
          />
        </h3>

        <p>Years of Excellence</p>
      </div>

      {/* 100+ */}

      <div className="stats-card">
        <FaUsers className="icon" />

        <h3>
          <CountUp
            end={100}
            duration={2.5}
            suffix="+"
            enableScrollSpy
            scrollSpyOnce
          />
        </h3>

        <p>Happy Clients</p>
      </div>

      {/* 300+ */}

      <div className="stats-card">
        <FaProjectDiagram className="icon" />

        <h3>
          <CountUp
            end={150}
            duration={2.5}
            suffix="+"
            enableScrollSpy
            scrollSpyOnce
          />
        </h3>

        <p>Projects Delivered</p>
      </div>

      {/* 150+ */}

      <div className="stats-card">
        <FaUserTie className="icon" />

        <h3>
          <CountUp
            end={10}
            duration={2.5}
            suffix="+"
            enableScrollSpy
            scrollSpyOnce
          />
        </h3>

        <p>Team Members</p>
      </div>

      {/* 24/7 */}

      <div className="stats-card">
        <FaHeadset className="icon" />

        <h3>
          <CountUp
            end={24}
            duration={2.5}
            enableScrollSpy
            scrollSpyOnce
          />
          /7
        </h3>

        <p>Technical Support</p>
      </div>

    </section>
  );
}